import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { AuthenticateService } from '../../common/services/authenticate.service';
import { GlobalFunction } from '../../common/core/global_function';
import { NotificationsService } from 'angular4-notifications';
import { AppGlobal } from '../../common/app.global';
import { postLoginRedirect } from '../../common/core/utils';

@Component({
    selector: 'app-root',
    templateUrl: 'authenticate.component.html',
})

export class AuthenticateComponent {
    email_label = "<i class='icon icon-profile'></i>";
    password_label = "<i class='icon icon-padlock'></i>";
    errorValue = "";
    public loading = false;
    constructor(private route: ActivatedRoute,
                private router: Router,
                private location: Location,
                public authenticate_service: AuthenticateService,
                public notification_service: NotificationsService,
                public appGlobal: AppGlobal) {
        document.title = 'Login';
        const token = localStorage.getItem('token');
        if (token) {
            postLoginRedirect(this.location, this.router, this.appGlobal, this.authenticate_service);
        }
    }

    notifications_options: any = {
        timeOut: 3000,
        showProgressBar: false,
        pauseOnHover: true,
        clickToClose: true
    };

    login() {
        var that = this;
        if (this.authenticate_service.validate()) {
            that.loading = true;
            this.authenticate_service.login().then(rs => {
                if (rs.code == 200) {
                    this.notification_service.success('Success','');
                    postLoginRedirect(this.location, this.router, this.appGlobal, this.authenticate_service);
                } else {
                    let errorMessage = 'Unknown error';
                    let rsJson = rs.json();
                    if (rsJson.error) {
                        if (rsJson.error === 'access_denied' && rsJson.error_description === 'The credentials cannot be authenticated.') {
                            errorMessage = 'Password is not correct';
                        } else {
                            errorMessage = rsJson.error_description || rsJson.error || errorMessage;
                        }
                    }
                    that.authenticate_service._error_api = {
                        password: errorMessage
                    };
                }
                that.loading = false;
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/application/authenticate/authenticate.component.ts